import React from 'react';
import { Box, Typography } from '@mui/material';
import { 
    Briefcase, 
    Users, 
    Landmark, 
    BarChart3, 
    FileText, 
    Receipt, 
    ChevronRight 
} from 'lucide-react';
import { Link } from 'react-router-dom';

const menuItems = [
    { icon: Briefcase, text: 'Jobs', path: '/employer/jobs' },
    { icon: Users, text: 'Employees', path: '/employer/employees' },
    { icon: Landmark, text: 'Salary Specification', path: '/employer/salary-specification' },
    { icon: BarChart3, text: 'Reports', path: '/employer/reports' },
    { icon: FileText, text: 'Contracts', path: '/employer/contracts' },
    { icon: Receipt, text: 'Invoices', path: '/employer/invoices' },
];

function CompanyNavMenu() {
    return (
        <Box
            sx={{
                borderRadius: 3, // rounded-xl
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: 1, // shadow-sm
                bgcolor: 'background.paper',
                overflow: 'hidden'
            }}
        >
            <Box component="ul" sx={{ m: 0, p: 0, listStyle: 'none' }}>
                {menuItems.map((item, index) => {
                    const IconComponent = item.icon;
                    return (
                        <React.Fragment key={index}>
                            <Box
                                component="li"
                                sx={{
                                    borderBottom: index < menuItems.length - 1 ? '1px solid' : 'none',
                                    borderColor: 'divider'
                                }}
                            >
                                <Box
                                    component={Link}
                                    to={item.path}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 2,
                                        px: 3, // px-6
                                        py: 2, // py-4
                                        textDecoration: 'none',
                                        color: 'text.primary',
                                        transition: 'background-color 0.2s',
                                        '&:hover': {
                                            bgcolor: 'action.hover', // hover:bg-accent equivalent
                                            '& .chevron-icon': {
                                                opacity: 1
                                            },
                                            '& .icon-box': {
                                                bgcolor: 'primary.main',
                                                color: 'primary.contrastText'
                                            }
                                        },
                                        position: 'relative'
                                    }}
                                >
                                    {/* Icon Box */}
                                    <Box
                                        className="icon-box"
                                        sx={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: 2, // rounded-lg
                                            bgcolor: 'action.selected', // bg-secondary equivalent
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'text.secondary',
                                            transition: 'all 0.2s'
                                        }}
                                    >
                                        <IconComponent size={18} />
                                    </Box>

                                    {/* Text */}
                                    <Typography
                                        component="span"
                                        sx={{
                                            flex: 1,
                                            fontWeight: 500
                                        }}
                                    >
                                        {item.text}
                                    </Typography>

                                    {/* ChevronRight Icon */}
                                    <Box
                                        className="chevron-icon"
                                        sx={{
                                            opacity: 0,
                                            transition: 'opacity 0.2s',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <ChevronRight size={20} />
                                    </Box>
                                </Box>
                            </Box>
                        </React.Fragment>
                    );
                })}
            </Box>
        </Box>
    );
}

export default CompanyNavMenu;
